var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "bg-light" }, [
    _c("div", { staticClass: "main-content" }, [_c("router-view")], 1),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "card rounded-0 mb-0 border-right-0 border-left-0 border-bottom-0 bottom-navigation",
        class: [_vm.hidden, _vm.hiddenXS, _vm.hiddenSM]
      },
      [
        _c("div", { staticClass: "card-body p-2" }, [
          _c("div", { staticClass: "d-flex" }, [
            _c(
              "div",
              {
                staticClass: "flex-fill text-center",
                on: {
                  click: function($event) {
                    return _vm.setMenu("home")
                  }
                }
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "no-style",
                    class: { "menu-text": _vm.activeMenu === "home" },
                    attrs: { to: "/job-posts" }
                  },
                  [
                    _c("div", [
                      _c("i", { staticClass: "fal fa-home-alt fa-lg" })
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-small" }, [
                      _vm._v("หน้าแรก")
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex-fill text-center",
                on: {
                  click: function($event) {
                    return _vm.setMenu("saved")
                  }
                }
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "no-style",
                    class: { "menu-text": _vm.activeMenu === "saved" },
                    attrs: {
                      to: _vm.jobUser
                        ? "/job-posts?type=saved"
                        : "/job-posts/profile"
                    }
                  },
                  [
                    _c("div", [
                      _c("i", { staticClass: "fal fa-check-circle fa-lg" })
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-small" }, [
                      _vm._v("งานที่ฉันสนใจ")
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex-fill text-center",
                on: {
                  click: function($event) {
                    return _vm.setMenu("profile")
                  }
                }
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "no-style",
                    class: { "menu-text": _vm.activeMenu === "profile" },
                    attrs: { to: "/job-posts/profile" }
                  },
                  [
                    _c("div", [
                      _c("i", { staticClass: "fal fa-user-circle fa-lg" })
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-small" }, [
                      _vm._v("บัญชีของฉัน")
                    ])
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d730240", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d730240","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobPost/Index.vue
// module id = 2314
// module chunks = 0